import React, { useRef, useState } from 'react';
import SyncMobileDevicesModal from '../ControlPanel/SyncMobileDevices/SyncMobileDevicesModal/index';
import { Box, CardMedia, IconButton, Typography } from '@mui/material';
import Premium from '../../../assets/images/PRO logo PMS green only.svg';
import styles from './styles';
import { FileOpen } from '@mui/icons-material';
import PropTypes from 'prop-types';
import { isMobile } from 'react-device-detect';

function FileUploadDialog({ open, handleClose, isLoading, handleUpload, showDateTimeRange, showCta2, hideLimit, type, fileSize }) {
  const classes = styles();

  const [selectedFile, setSelectedFile] = useState(null);
  const [isDragging, setIsDragging] = useState(false);
  const [error, setError] = useState(null);
  const dropAreaRef = useRef(null);
  const fileInputRef = useRef(null);

  const allowedTypes = {
    csv: 'text/csv',
    json: 'application/json'
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    validateFile(file);
  };

  const handleDragOver = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setIsDragging(true);
  };

  const handleDragLeave = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setIsDragging(false);
  };

  const handleDrop = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setIsDragging(false);
    const file = e.dataTransfer.files[0];
    validateFile(file);
    e.dataTransfer.clearData();
  };

  const validateFile = (file) => {
    if (file && file.type === allowedTypes[type]) {
      setSelectedFile(file);
      setError(null);
    } else {
      setSelectedFile(null);
      setError(`Only ${type.toUpperCase()} files are allowed`);
    }
  };

  const handleIconClick = () => {
    fileInputRef.current.click();
  };

  const handleFileUpload = () => {
    if (!selectedFile) {
      setError(`Select a ${type} file to upload`);
      return;
    }
    handleUpload(selectedFile);
  };

  return (
    <div>
      <SyncMobileDevicesModal
        open={open}
        onClose={handleClose}
        handleClose={handleClose}
        cta2Label={'Upload'}
        cta2Action={handleFileUpload}
        showCta2={showCta2}
        showDateTimeRange={showDateTimeRange}
        cta2Disabled={isLoading || !selectedFile}
        mobile={isMobile}
      >
        <CardMedia
          component="img"
          image={Premium}
          className={classes.logo}
        />
        <Typography variant="h4" gutterBottom component="div" style={{ textAlign: 'center' }}>
          {isLoading ? 'Uploading...' : 'Add or select media'}
        </Typography>
        <Box
          className={isDragging ? classes.dragDrop : classes.dropArea}
          ref={dropAreaRef}
          onDragOver={handleDragOver}
          onDragLeave={handleDragLeave}
          onDrop={handleDrop}
        >
          <input
            type="file"
            onChange={handleFileChange}
            style={{ display: 'none' }}
            id="fileInput"
            ref={fileInputRef}
            accept={allowedTypes[type]}
          />
          <label htmlFor="fileInput" style={{ cursor: 'pointer' }}>
            Drop files here to upload them or press button
            <br />
            <br />
            <IconButton
              edge="end"
              sx={{ marginRight: '1%' }}
              onClick={handleIconClick}
            >
              <FileOpen />
            </IconButton>
          </label>
        </Box>
        {error && <Box className={classes.errorMessage}>{error}</Box>}
        {selectedFile && <Box className={classes.selectedFileMessage}>Selected file: {selectedFile.name}</Box>}
        <p className={classes.fileDescription}>
          Allowed file upload: <strong>one file only</strong>
          {!hideLimit && <> <br />File must be less than <strong>{fileSize || 2} MB</strong></>}
          <br />
          Allowed file types: <strong>{type || 'csv'}</strong>
        </p>
      </SyncMobileDevicesModal>
    </div>
  );
}

FileUploadDialog.propTypes = {
  open: PropTypes.bool,
  handleClose: PropTypes.func,
  isLoading: PropTypes.bool,
  handleUpload: PropTypes.func,
  showDateTimeRange: PropTypes.bool,
  showCta2: PropTypes.bool,
  hideLimit: PropTypes.bool,
  type: PropTypes.oneOf(['csv', 'json']),
  fileSize: PropTypes.number
};

FileUploadDialog.defaultProps = {
  open: false,
  showDateTimeRange: false,
  showCta2: true,
  isLoading: false,
  hideLimit: false,
  type: 'csv'
};

export default FileUploadDialog;
